var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const isAutocompleteCategories = /* @__PURE__ */ __name((autocomplete) => !autocomplete.some((option) => typeof option === "string"), "isAutocompleteCategories");

export { isAutocompleteCategories };
//# sourceMappingURL=is-autocomplete-categories.js.map
